module.exports = __webpack_public_path__ + "img/onwumah.c549fc09.png";